export default {
  GET_ALL_DRIVERS(state, data) {
    state.all_drivers = data.data || []
  },

  GET_DRIVER(state, data) {
    state.driver = data.data ? data.data[0] : {} // Your backend returns array with single item
  },

  GET_DRIVERS(state, data) {
    state.drivers = data.data || []
  },

  DRIVER_ERRORS(state, errors) {
    state.errors = errors.messages || errors.message || []
  },

  CLEAR_DRIVER_ERRORS(state) {
    state.errors = []
  }
}